import axios from "../api";

export interface D2DInventoryItem {
  partNumber: string;
  quantity: number;
  action: boolean;
}

export interface D2DInventoryResponse {
  success: boolean;
  message?: string;
  data?: any;
}

export interface ID2DInventoryApi {
  processInventory: (
    url: string,
    payload: D2DInventoryItem[],
    accountId: string,
    userId: string,
    token: string
  ) => Promise<D2DInventoryResponse>;
}

const D2DInventoryApi: ID2DInventoryApi = {
  processInventory: (
    url: string,
    payload: D2DInventoryItem[],
    accountId: string,
    userId: string,
    token: string
  ): Promise<D2DInventoryResponse> =>
    axios
      .postWithRetries(`${url}/v1/d2d-inventory/d2dInventory`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          accountId,
          userId,
        },
      })
      .then((response: any) => response.data),
};

export default D2DInventoryApi;
